export class UpdateGwsBackupFilterRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gwsFilterJson",
            "baseName": "gwsFilterJson",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateGwsBackupFilterRequest.attributeTypeMap;
    }
    constructor() {
    }
}
